import React, { useState, useEffect, useCallback } from 'react'
import { Box, Divider } from '@mui/material'
import { Alert } from '../../../../contexts/ApplicationSuiteProvider'
import AlertNotificationTimeOfDayForm from '../../../../components/alerts/alertForms/AlertNotificationTimeOfDayForm'
import setNestedValue from 'lodash.set'
import AlertSettingsActionBar from '../AlertSettingsActionBar'
import TradeParamsReadView from '../TradeParamsReadView'
import SectionTitle from '../../../../layout/settingsMenu/SectionTitle'

interface EditTabProps {
  alert: Alert
}

const EditTab: React.FC<EditTabProps> = ({ alert }) => {
  const [alertToUpdate, setAlertToUpdate] = useState(alert)

  useEffect(() => {
    setAlertToUpdate(alert)
  }, [alert])

  const handleAlertKeyChange = useCallback(
    (key: string, value: any) => {
      setAlertToUpdate((prev) => setNestedValue({ ...prev }, key, value))
    },
    [setAlertToUpdate]
  )

  return (
    <>
      <Box
        p={2}
        sx={{
          flexGrow: 1,
          overflowY: 'auto',
        }}
      >
        <AlertNotificationTimeOfDayForm
          alert={alertToUpdate}
          onAlertKeyChange={handleAlertKeyChange}
          settings={{ symbolDisabled: true, patternDisabled: true, dayCheckmark: false }}
        />

        {alert.trading?.options && (
          <>
            <Divider sx={{ my: 2 }} />
            <SectionTitle title="Trade Parameters" />
            <TradeParamsReadView alert={alert} />
          </>
        )}
      </Box>

      {/* Fixed Bottom Save Button */}
      <AlertSettingsActionBar alert={alertToUpdate} inEditMode />
    </>
  )
}

export default EditTab
